import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Testimonials = ({ testimonials }) => {
  const defaultTestimonials = [
    {
      id: "1",
      name: "Sarah Mitchell",
      rating: 5,
      message: "Working with Deepa transformed my approach to leadership. Her insights helped me navigate a challenging career transition with confidence and clarity.",
      service_type: "1-on-1 Coaching",
    },
    {
      id: "2",
      name: "James Chen",
      rating: 5,
      message: "The cohort-based program was exactly what I needed. Learning alongside peers while having Deepa's expert guidance accelerated my growth tremendously.",
      service_type: "Cohort Coaching",
    },
    {
      id: "3",
      name: "Priya Sharma",
      rating: 5,
      message: "Deepa's ability to identify limiting beliefs and provide actionable strategies is remarkable. I've become a more confident and effective leader.",
      service_type: "1-on-1 Coaching",
    },
  ];

  const displayTestimonials = testimonials?.length > 0 ? testimonials : defaultTestimonials;

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${
          i < rating ? "fill-accent text-accent" : "text-muted"
        }`}
      />
    ));
  };

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="uppercase tracking-[0.2em] text-xs font-semibold text-primary">
            Testimonials
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl font-bold tracking-tight">
            What Clients Say
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Hear from professionals who have transformed their leadership journey 
            through coaching.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {displayTestimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              data-testid={`testimonial-card-${index}`}
              className="testimonial-card border-border/50 bg-background"
            >
              <CardContent className="pt-8 pb-6 px-6">
                <Quote className="h-8 w-8 text-primary/20 mb-4" />
                
                <div className="flex gap-1 mb-4">
                  {renderStars(testimonial.rating)}
                </div>
                
                <p className="text-muted-foreground leading-relaxed mb-6">
                  "{testimonial.message}"
                </p>
                
                <div className="border-t border-border/50 pt-4">
                  <p className="font-semibold">{testimonial.name}</p>
                  {testimonial.service_type && (
                    <p className="text-sm text-muted-foreground">
                      {testimonial.service_type}
                    </p>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
